// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__26Lq8","comment":"styles_comment__Z82Pm"};